<template>
  <!-- 录音笔说明书 -->
  <article class="soundin-user-manual-page" ref="articleEl">
    <h2>包装说明</h2>
    <figure>
      <img
        src="~@/assets/img/recorderPenManual/image1@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image1@2x.png 2x,
          @/assets/img/recorderPenManual/image1@3x.png 3x
        "
      />
    </figure>
    <h2>1 快速开始</h2>
    <h3>1.1 连接方式</h3>
    <p>扫码下载灵云听语APP；</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image2@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image2@2x.png 2x,
          @/assets/img/recorderPenManual/image2@3x.png 3x
        "
      />
      <p>扫码下载APP</p>
    </figure>
    <p>
      按住红色开机键3秒，出现“灵云”logo即表示设备开始工作，首次开机录音笔将引导您连接APP。
    </p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image3@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image3@2x.png 2x,
          @/assets/img/recorderPenManual/image3@3x.png 3x
        "
      />
    </figure>
    <p>打开听语APP</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image4@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image4@2x.png 2x,
          @/assets/img/recorderPenManual/image4@3x.png 3x
        "
      />
    </figure>
    <h3>1.2 其他连接方式</h3>
    <p>
      确保设备在转录模式下打开听语APP点击首页右上角“+”选择您的设备，20秒内在录音笔确认即可完成连接
    </p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image5@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image5@2x.png 2x,
          @/assets/img/recorderPenManual/image5@3x.png 3x
        "
      />
    </figure>
    <h3>1.3 录音笔操作方式</h3>
    <h4>1.3.1 功能选择</h4>
    <p>主屏幕上下滑动选择功能，点按左上角可返回上一级或右滑返回上一级。</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image6@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image6@2x.png 2x,
          @/assets/img/recorderPenManual/image6@3x.png 3x
        "
      />
    </figure>
    <h4>1.3.2 长按删除文件</h4>
    <p>长按录音文件或语音备忘，会有是否删除弹窗，点击确认即可删除。</p>

    <h2>2 转录模式</h2>
    <p>将录音笔模式切换键切换至如图位置，即表示当前为转录模式。</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image7@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image7@2x.png 2x,
          @/assets/img/recorderPenManual/image7@3x.png 3x
        "
      />
      <p>转录模式</p>
    </figure>
    <h3>2.1 开始转录</h3>
    <h4>2.1.1 未连接APP</h4>
    <p>
      单击录音笔录音键即可开始拾音，再次点击即可结束，音频文件会存储在录音笔中，连接APP后可进行转写。
    </p>
    <h4>2.1.2 已连接APP</h4>
    <p>
      单机录音笔录音键即可开始，APP随即开始实时转写，可在APP中暂停和停止录音。
    </p>
    <h4>2.1.3 导入文件到APP</h4>
    <p>将录音笔连接APP，依次点击APP首页“上传音频-录音笔”即可转写所需文件。</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image8@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image8@2x.png 2x,
          @/assets/img/recorderPenManual/image8@3x.png 3x
        "
      />
    </figure>

    <h3>2.2 语音备忘</h3>
    <p>
      长按录音笔录音键即可录制最长1分钟的语音备忘，录音时间即将到达上限时会有文字提示，松开自动保存。
    </p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image9@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image9@2x.png 2x,
          @/assets/img/recorderPenManual/image9@3x.png 3x
        "
      />
    </figure>

    <h3>2.3 录音设置</h3>
    <p>主屏幕向下滑动至录音设置</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image10@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image10@2x.png 2x,
          @/assets/img/recorderPenManual/image10@3x.png 3x
        "
      />
    </figure>
    <p>可选择设置项有，录音模式、降噪方式、隐蔽录音。</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image11@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image11@2x.png 2x,
          @/assets/img/recorderPenManual/image11@3x.png 3x
        "
      />
    </figure>
    <h4>2.3.1 录音模式设置</h4>
    <p>录音模式包含会议、课堂、采访、多媒体模式，可根据实际情况选择。</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image12@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image12@2x.png 2x,
          @/assets/img/recorderPenManual/image12@3x.png 3x
        "
      />
    </figure>
    <h4>2.3.2 降噪模式</h4>
    <p>
      降噪模式有真实音质、人声增强两项，真实音质将保留人声以及环境声，人声增强将过滤环境噪声增强人声。
    </p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image13@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image13@2x.png 2x,
          @/assets/img/recorderPenManual/image13@3x.png 3x
        "
      />
    </figure>
    <h4>2.3.3 隐蔽录音</h4>
    <p>隐蔽录音开启状态下，转录时指示灯不会亮起。</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image14@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image14@2x.png 2x,
          @/assets/img/recorderPenManual/image14@3x.png 3x
        "
      />
    </figure>

    <h2>3 佩戴模式</h2>
    <p>
      佩戴模式下录音笔可作为外置蓝牙麦克风拾音，将录音笔模式切换键切换至如图位置，即表示当前为佩戴模式。
    </p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image15@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image15@2x.png 2x,
          @/assets/img/recorderPenManual/image15@3x.png 3x
        "
      />
      <p>佩戴模式</p>
    </figure>
    <h3>3.1 蓝牙连接</h3>
    <p>
      佩戴模式下在手机蓝牙列表中找到“JT01-xxxx”完成连接，连接成功后录音笔蓝牙图标会亮起。
    </p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image16@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image16@2x.png 2x,
          @/assets/img/recorderPenManual/image16@3x.png 3x
        "
      />
    </figure>
    <h3>3.2 有线连接</h3>
    <p>
      佩戴模式下，将连接方式设置为有线连接，即可通过音频线与手机、相机、电脑设备等连接。<br />
      <br />
      手机连接方法：具备3.5mm接口可直接相连，不具备则需要自备Type-c转3.5mm转接线。<br />
      <br />
      相机连接方法：相机需要具备3.5mm Mic输入接口。<br />
      <em class="important"
        >* 音频线需单独购买（音频线提供3节、4节两种分别适配不同设备）。</em
      >
    </p>

    <h2>4 本机设置</h2>
    <h3>4.1 亮度设置</h3>
    <p>依次点击“本机设置-用户设置-屏幕亮度”。</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image17@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image17@2x.png 2x,
          @/assets/img/recorderPenManual/image17@3x.png 3x
        "
      />
    </figure>
    <h3>4.2 屏幕轻点唤醒设置</h3>
    <p>
      依次点击“本机设置-用户设置-屏幕唤醒”，开启状态下只需要轻点屏幕唤醒录音笔。
    </p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image18@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image18@2x.png 2x,
          @/assets/img/recorderPenManual/image18@3x.png 3x
        "
      />
    </figure>
    <h3>4.3 震动反馈设置</h3>
    <p>依次点击“本机设置-用户设置-震动反馈”</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image19@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image19@2x.png 2x,
          @/assets/img/recorderPenManual/image19@3x.png 3x
        "
      />
    </figure>
    <h3>4.4 日期时间设置</h3>
    <p>依次点击“本机设置-系统设置-系统时间”即可设置日期和时间</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image20@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image20@2x.png 2x,
          @/assets/img/recorderPenManual/image20@3x.png 3x
        "
      />
    </figure>
    <h3>4.5 百分比电量显示</h3>
    <p>
      依次点击“本机设置-系统设置-电池百分比”即可在录音笔主屏幕显示百分比电量信息。
    </p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image21@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image21@2x.png 2x,
          @/assets/img/recorderPenManual/image21@3x.png 3x
        "
      />
    </figure>
    <h3>4.6 自动关机设置</h3>
    <p>
      依次点击“本机设置-系统设置-自动关机”，选择相应时间，如选择1小时则在您无操作1小时后自动关机。
    </p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image22@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image22@2x.png 2x,
          @/assets/img/recorderPenManual/image22@3x.png 3x
        "
      />
    </figure>
    <h3>4.7 自动息屏</h3>
    <p>
      依次点击“本机设置-系统设置-自动息屏”，选择相应时间，如选择30秒则在您无操作30秒后自动息屏。
    </p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image23@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image23@2x.png 2x,
          @/assets/img/recorderPenManual/image23@3x.png 3x
        "
      />
    </figure>
    <h3>4.8 系统语言设置</h3>
    <p>依次点击“本机设置-系统设置-系统语言”选择对应语言即可。</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image24@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image24@2x.png 2x,
          @/assets/img/recorderPenManual/image24@3x.png 3x
        "
      />
    </figure>

    <h2>5 查看本机信息</h2>
    <h3>5.1 查看录音笔剩余空间</h3>
    <p>方式一：连接听语APP后，点击首页右上角-空间管理</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image25@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image25@2x.png 2x,
          @/assets/img/recorderPenManual/image25@3x.png 3x
        "
      />
    </figure>
    <p>方式二：录音笔中依次点击“本机设置-关于本机-本机信息”即可查看剩余空间</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image26@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image26@2x.png 2x,
          @/assets/img/recorderPenManual/image26@3x.png 3x
        "
      />
    </figure>
    <h3>5.2 查看录音笔SN</h3>
    <p>录音笔中依次点击“本机设置-关于本机-本机信息”即可查看SN</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image26@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image26@2x.png 2x,
          @/assets/img/recorderPenManual/image26@3x.png 3x
        "
      />
    </figure>
    <h3>5.3 查看固件版本</h3>
    <p>录音笔中依次点击“本机设置-关于本机-本机信息”即可查看SN</p>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image26@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image26@2x.png 2x,
          @/assets/img/recorderPenManual/image26@3x.png 3x
        "
      />
    </figure>

    <h2>6 导出文件到电脑</h2>
    <p>使用随机附赠Type-c接口线缆连接电脑，可复制音频文件至电脑。</p>

    <h2>7 充电</h2>
    <p>随机附赠Type-c接口充电线，可连接电脑或充电头为录音笔充电。</p>

    <h2>8 双机协同（开发中…）</h2>
    <p>
      “双机协同”这是一个非常适合户外视频场景的功能，它能够实现远距离收音，当然前提是需要两只灵云JTAM_01录音笔，具体使用时，一只设置为发射端，夹在衣领上；另一只设置为接收端，用转接线连接到手机或者相机等设备上，两个灵云JTAM_01之间通过蓝牙进行连接，这样就可以了。双机协同模式下，创作者就可以在更大的范围内活动。比如，将您的拍摄设备用三脚固定，拍摄一些舞蹈、孩子嬉闹、宠物玩耍等内容，这样录制的声音既稳定又清晰，方便后期剪辑处理。想象一下如果用手机或者相机麦克风直接去收音的话，可能最终的声音会忽大忽小，杂乱无章。
    </p>

    <h2>9 参数指标</h2>
    <figure>
      <img
        src="@/assets/img/recorderPenManual/image27@2x.png"
        srcset="
          @/assets/img/recorderPenManual/image27@2x.png 2x,
          @/assets/img/recorderPenManual/image27@3x.png 3x
        "
      />
    </figure>
  </article>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
  name: 'Soundin',
  data () {
    return {
      imageUrlList: [],
      imageElList: []
    }
  },
  mounted () {
    const articleEl = this.$refs.articleEl

    this.imageElList = [...articleEl.querySelectorAll('figure>img')]
    this.imageUrlList = this.imageElList.map(item => item.src)

    const viewImage = (ev) => {
      const targetEl = ev.target
      if (!(targetEl instanceof HTMLImageElement)) {
        return
      }

      ImagePreview({
        images: this.imageUrlList,
        startPosition: this.imageElList.findIndex(el => el === targetEl)
      })
    }
    articleEl.addEventListener('click', viewImage)

    this.$once('hook:beforeDestroy', () => {
      articleEl.removeEventListener('click', viewImage)
    })
  }

}
</script>

<style lang="scss" scoped>
.soundin-user-manual-page {
  text-align: left;
  padding: 50px 30px;
  h2,
  h3 {
    font-size: 28px;
    color: #333;
    font-weight: bold;
    line-height: 42px;
    margin-bottom: 14px;
  }

  h4,
  p {
    font-size: 26px;
    line-height: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    margin-bottom: 30px;
  }

  p {
    color: #666;
  }

  .important {
    color: #333;
    font-weight: bold;
  }
  figure {
    text-align: center;
  }
  img {
    max-width: 100%;
  }
}
</style>
